import { BottomSheet } from '../../components';
import { TransactionForm, type EntryDraft } from '../today/TransactionForm';

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (draft: EntryDraft) => void;
};

/**
 * BottomSheet wrapper around TransactionForm for one-off income entries
 * created from the Plan tab. Type is locked to 'income' so the form
 * shows the right placeholder + category list, and the spread chips
 * are visible (TransactionForm enables them for both directions). The
 * NumPad's Done key reads "Save" and commits via onSave.
 *
 * Distinct from the recurring ScheduledItemSheet: this creates a
 * regular Transaction (with optional spreadDays), not a scheduled item
 * with a frequency. Used for variable-income flows — gigs, freelance,
 * commission — where each paycheck is its own event.
 */
export function OneOffIncomeSheet({ open, onClose, onSave }: Props) {
  return (
    <BottomSheet open={open} onClose={onClose} title="Log a paycheck">
      <p className="px-card-pad pb-1 text-[13px] text-text-secondary text-center leading-relaxed">
        For freelancers, gigs, and one-off income. Pick a spread window
        below to amortize a lump-sum check across a steady income
        window, or leave it on "Today" for a single-day spike.
      </p>
      <TransactionForm
        type="income"
        doneLabel="Save"
        onSave={(draft) => {
          onSave(draft);
          onClose();
        }}
      />
    </BottomSheet>
  );
}
